import { useTranslation } from 'react-i18next';

import { DatePickerField } from 'fields';

import type { IPaymentDue } from './types';

export default function PaymentDue({ disabled }: IPaymentDue) {
  const { t } = useTranslation('CreateOrder');

  return (
    <DatePickerField
      required
      disabled={disabled}
      name="paymentTerms.paymentDueDate"
      label={t('ProductForm.labels.paymentDue')}
      disablePast
    />
  );
}
